module.exports = __webpack_public_path__ + "static/media/molotov.7ba33ac3.svg";